<template>
  <div class="image-uploader">
    <div v-if="!image" class="image-uploader-content without-image">
      <div class="image-uploader-icon">
        <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="image" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="image-icon"><path fill="#919ea9" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm16 336c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V112c0-8.822 7.178-16 16-16h416c8.822 0 16 7.178 16 16v288zM112 232c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56 25.072 56 56 56zm0-80c13.234 0 24 10.766 24 24s-10.766 24-24 24-24-10.766-24-24 10.766-24 24-24zm207.029 23.029L224 270.059l-31.029-31.029c-9.373-9.373-24.569-9.373-33.941 0l-88 88A23.998 23.998 0 0 0 64 344v28c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-92c0-6.365-2.529-12.47-7.029-16.971l-88-88c-9.373-9.372-24.569-9.372-33.942 0zM416 352H96v-4.686l80-80 48 48 112-112 80 80V352z" class=""></path></svg>
      </div>
      <p>Add a logo by browsing from your device.</p>
      <input type="file" @change="onFileChange" class="file-upload"/>
    </div>
    <div v-else class="image-uploader-content with-image">
      <img :src="image"/>
      <button type="button" @click="removeImage">Remove image</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceFormImageUpload',
  data () {
    return {
      image: ''
    }
  },
  methods: {
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createImage(files[0])
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
        // Emit the image data url value
        this.$emit('imageCreated', vm.image)
      }

      reader.readAsDataURL(file)
    },
    removeImage () {
      this.image = ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/Variables.scss';

.image-uploader {
  align-items: center;
  background: #f4f6f8;
  border: 1px solid $grey;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  padding: 1.875rem .9375rem;
  text-align: center;
  margin-bottom: 15px;

  .image-uploader-content {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &.without-image {

      .image-uploader-icon {
        max-width: 20%;

        svg {
          fill: #919ea9;
          height: 100%;
          width: 100%;
        }

      }

      p {
        max-width: 60%;
      }

      .file-upload {
        border: 1px dashed #919ea9;
        display: block;
        margin-top: .9375rem;
        padding: .9375rem;
        width: 100%;
      }

    }

    &.with-image {
      flex-direction: column;
      max-width: 80%;

      img {
        max-height: 80%;
        max-width: 80%;
      }

    }

  }

}
</style>
